export const messages = {
  en: {
    propertyFee: {
      title: 'Property Fee Management',
      feeName: 'Property Fee',
      paymentHistory: 'Payment History',
      selectStartTime: 'Select start time',
      selectEndTime: 'Select end time',
      searchNow: 'Search Now',
      reset: 'Reset',
      paymentId: 'Payment ID',
      cycle: 'Cycle(Month)',
      paymentMethod: 'Payment Method',
      receivableAmount: 'Receivable Amount(Yuan)',
      receivedAmount: 'Received Amount(Yuan)',
      paymentTime: 'Payment Time',
      startTime: 'Start Time',
      endTime: 'End Time',
      cashier: 'Cashier',
      status: 'Status',
      remark: 'Remark',
      operation: 'Operation',
      applyRefund: 'Apply Refund',
      discount: 'Discount',
      viewInFee: 'view in fee',
      accountDeduction: 'Account Deduction'
    },
    viewMainFee: {
      feeInfo: 'Fee Information',
      feeId: 'Fee ID',
      feeFlag: 'Fee Flag',
      feeType: 'Fee Type',
      payerObj: 'Payer Object',
      feeItem: 'Fee Item',
      feeStatus: 'Fee Status',
      startTime: 'Create Time',
      billingStartTime: 'Billing Start Time',
      billingEndTime: 'Billing End Time',
      feeAmount: 'Fee Amount(Yuan)',
      batch: 'Batch',
      area: 'Area(㎡)',
      unitPrice: 'Unit Price(Yuan/㎡)',
      additionalFee: 'Additional Fee(Yuan)',
      fixedFee: 'Fixed Fee(Yuan)'
    },
    returnPayFee: {
      fillRefundReason: 'Fill Refund Reason',
      paymentId: 'Payment',
      cycle: 'Cycle',
      receivableAmount: 'Receivable Amount',
      receivedAmount: 'Received Amount',
      paymentTime: 'Payment Time',
      refundReason: 'Refund Reason',
      enterRefundReason: 'Please enter refund reason',
      submitRefund: 'Submit Refund Application',
      refundReasonRequired: 'Refund reason is required',
      refundReasonTooLong: 'Refund reason cannot exceed 200 characters'
    },
    viewFeeDetailDiscount: {
      discount: 'Discount',
      discountName: 'Discount Name',
      discountType: 'Discount Type',
      ruleName: 'Rule Name',
      discountRule: 'Discount Rule',
      discountAmount: 'Discount Amount(Yuan)',
      breach: 'Breach'
    }
  },
  zh: {
    propertyFee: {
      title: '物业费管理',
      feeName: '物业费',
      paymentHistory: '缴费历史',
      selectStartTime: '请选择开始时间',
      selectEndTime: '请选择结束时间',
      searchNow: '马上查询',
      reset: '重置',
      paymentId: '缴费ID',
      cycle: '周期(单位:月)',
      paymentMethod: '缴费方式',
      receivableAmount: '应收金额(单位:元)',
      receivedAmount: '实收金额(单位:元)',
      paymentTime: '缴费时间',
      startTime: '缴费起始时间',
      endTime: '缴费结束时间',
      cashier: '收银员',
      status: '状态',
      remark: '备注',
      operation: '操作',
      applyRefund: '申请退费',
      discount: '折扣',
      viewInFee: '费用中查看',
      accountDeduction: '账户扣款'
    },
    viewMainFee: {
      feeInfo: '费用信息',
      feeId: '费用ID',
      feeFlag: '费用标识',
      feeType: '费用类型',
      payerObj: '付费对象',
      feeItem: '费用项',
      feeStatus: '费用状态',
      startTime: '建账时间',
      billingStartTime: '计费开始时间',
      billingEndTime: '计费结束时间',
      feeAmount: '费用金额(单位:元)',
      batch: '批次',
      area: '面积(㎡)',
      unitPrice: '单价(元/㎡)',
      additionalFee: '附加费(元)',
      fixedFee: '固定费(元)'
    },
    returnPayFee: {
      fillRefundReason: '填写退费原因',
      paymentId: '缴费',
      cycle: '周期',
      receivableAmount: '应收金额',
      receivedAmount: '实收金额',
      paymentTime: '缴费时间',
      refundReason: '退费原因',
      enterRefundReason: '请输入退费原因',
      submitRefund: '提交退费申请',
      refundReasonRequired: '退费原因不能为空',
      refundReasonTooLong: '退费原因不能超过200位'
    },
    viewFeeDetailDiscount: {
      discount: '折扣',
      discountName: '折扣名称',
      discountType: '折扣类型',
      ruleName: '规则名称',
      discountRule: '折扣规则',
      discountAmount: '折扣金额(元)',
      breach: '违约'
}
  },
  'zh-TW': {
    propertyFee: {
      title: '管理費管理',
      feeName: '管理費',
      paymentHistory: '繳費歷史',
      selectStartTime: '請選擇開始時間',
      selectEndTime: '請選擇結束時間',
      searchNow: '馬上查詢',
      reset: '重置',
      paymentId: '繳費ID',
      cycle: '週期(單位:月)',
      paymentMethod: '繳費方式',
      receivableAmount: '應收金額(單位:元)',
      receivedAmount: '實收金額(單位:元)',
      paymentTime: '繳費時間',
      startTime: '繳費起始時間',
      endTime: '繳費結束時間',
      cashier: '收銀員',
      status: '狀態',
      remark: '備註',
      operation: '操作',
      applyRefund: '申請退費',
      discount: '折扣',
      viewInFee: '費用中查看',
      accountDeduction: '帳戶扣款'
    },
    viewMainFee: {
      feeInfo: '費用資訊',
      feeId: '費用ID',
      feeFlag: '費用標識',
      feeType: '費用類型',
      payerObj: '付費對象',
      feeItem: '費用項',
      feeStatus: '費用狀態',
      startTime: '建帳時間',
      billingStartTime: '計費開始時間',
      billingEndTime: '計費結束時間',
      feeAmount: '費用金額(單位:元)',
      batch: '批次',
      area: '面積(㎡)',
      unitPrice: '單價(元/㎡)',
      additionalFee: '附加費(元)',
      fixedFee: '固定費(元)'
    },
    returnPayFee: {
      fillRefundReason: '填寫退費原因',
      paymentId: '繳費',
      cycle: '週期',
      receivableAmount: '應收金額',
      receivedAmount: '實收金額',
      paymentTime: '繳費時間',
      refundReason: '退費原因',
      enterRefundReason: '請輸入退費原因',
      submitRefund: '提交退費申請',
      refundReasonRequired: '退費原因不能為空',
      refundReasonTooLong: '退費原因不能超過200位'
    },
    viewFeeDetailDiscount: {
      discount: '折扣',
      discountName: '折扣名稱',
      discountType: '折扣類型',
      ruleName: '規則名稱',
      discountRule: '折扣規則',
      discountAmount: '折扣金額(元)',
      breach: '違約'
    }
  }
}